import { styled } from '@mui/material/styles';
import Section from './Section';
import { FormattedMessage } from 'react-intl';
import ListItemButton from '@mui/material/ListItemButton';
import Checkbox from '@/components/Checkbox/Checkbox';
import { useQuery } from '@tanstack/react-query';
import { fetchFilters } from '@/lib/api';
import FilterOptionsUnavailable from './FilterOptionsUnavailable';

const FileFormatCompliance = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const { data, isError } = useQuery({
    queryKey: ['filters'],
    queryFn: fetchFilters,
  });
  const fileFormatItems =
    data?.compliance_documents_file_format.map((item) => ({
      id: item,
      label: item,
    })) || [];

  const handleToggle = (selectedId: string) => () => {
    const currentIndex = value.findIndex((v) => v === selectedId);
    const newChecked = [...value];

    if (currentIndex === -1) {
      newChecked.push(selectedId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked);
  };

  return (
    <Section
      title={
        <FormattedMessage
          id="fileFormat"
          defaultMessage="File Format"
        />
      }
      mode={mode}
      defaultOpen={value.length > 0}
    >
      {isError && !data ? (
        <FilterOptionsUnavailable />
      ) : (
        fileFormatItems.map(({ id, label }) => (
          <StyledButton
            key={id}
            onClick={handleToggle(id)}
            aria-label={`Toggle ${id} file format`}
          >
            <StyledCheckbox checked={value.includes(id)} mode={mode} />
            <Label>{label}</Label>
          </StyledButton>
        ))
      )}
    </Section>
  );
};

const StyledButton = styled(ListItemButton)({
  padding: '4px 0',
});

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: `0 ${theme.spacing(1)} 0 0`,
}));

const Label = styled('div')({
  fontSize: 14,
});

export default FileFormatCompliance;
